import { IStairConfig } from '@stair-craft/common/util';

import { IStairNorms } from '../../norms';

export const DEFAULT_DIAMETER: number = 1600;
const DEFAULT_ROTATION: number = 360;
// Pole sized so the step's inner edge sits flush against the pole. Required to satisfy СП 54.13330
// (former СНиП 2.08.01-89): width at narrow edge measured 150mm from inner edge must be ≥ 100mm
// — radius=140 gives chord ≈ 113mm.
export const POLE_DIAMETER: number = 280;
export const POLE_RADIUS: number = POLE_DIAMETER / 2;

/** Resolved spiral geometry shared by every spiral helper; produced here, consumed everywhere. */
export interface ISpiralLayout {
    stepCount: number;
    riserHeight: number;
    outerRadius: number;
    innerRadius: number;
    treadWidth: number;
    totalRotationDeg: number;
    anglePerStepRad: number;
    walkingLineR: number;
    treadDepthAtWalkingLine: number;
}

export function calculateLayout(config: IStairConfig, norms: IStairNorms): ISpiralLayout {
    const totalRise: number = config.floorHeight + config.floorThickness;
    const diameter: number = config.spiralDiameter ?? DEFAULT_DIAMETER;
    const outerRadius: number = diameter / 2;
    const innerRadius: number = POLE_RADIUS;
    const treadWidth: number = outerRadius - innerRadius;
    const totalRotationDeg: number = config.spiralRotation ?? DEFAULT_ROTATION;

    let stepCount: number;
    if (config.stepCount != null) {
        stepCount = config.stepCount;
    } else if (config.riserHeight != null) {
        stepCount = Math.round(totalRise / config.riserHeight);
    } else {
        stepCount = Math.round(totalRise / norms.riserHeightIdeal);
    }
    stepCount = Math.max(3, stepCount);

    let riserHeight: number = config.riserHeight ?? totalRise / stepCount;
    if (config.riserHeight != null) {
        stepCount = Math.round(totalRise / riserHeight);
        stepCount = Math.max(3, stepCount);
    }
    riserHeight = totalRise / stepCount;

    // stepCount risers, stepCount-1 visible treads
    const anglePerStepRad: number = (totalRotationDeg * Math.PI) / 180 / (stepCount - 1);

    // Walking line at midpoint between inner and outer radius
    const walkingLineR: number = (innerRadius + outerRadius) / 2;
    const treadDepthAtWalkingLine: number = 2 * walkingLineR * Math.sin(anglePerStepRad / 2);

    return {
        stepCount,
        riserHeight,
        outerRadius,
        innerRadius,
        treadWidth,
        totalRotationDeg,
        anglePerStepRad,
        walkingLineR,
        treadDepthAtWalkingLine,
    };
}
